const SITE_CONFIG = {
  SITE_NAME: 'Study with New Zealand',
  SITE_ROOT_PATH: '/',
  SITE_PROD_BASE_URL: 'https://www.studywithnewzealand.govt.nz',
}

export default SITE_CONFIG
